import { globalWindow } from './global';
export var isMiniAli = typeof my !== 'undefined' && !!my && typeof my.showToast === 'function';
var screenWidth;
var screenHeight;
var windowWidth;
var windowHeight;

if (isMiniAli) {
  var myOptions = my.getSystemInfoSync();
  screenWidth = myOptions.screenWidth;
  screenHeight = myOptions.screenHeight;
  windowWidth = myOptions.windowWidth;
  windowHeight = myOptions.windowHeight;
} else {
  var innerWidth = globalWindow.innerWidth,
      innerHeight = globalWindow.innerHeight;
  screenWidth = innerWidth;
  screenHeight = innerHeight;
  windowWidth = innerWidth;
  windowHeight = innerHeight;
}

export var screen = {
  width: screenWidth,
  height: screenHeight,
  availWidth: windowWidth,
  availHeight: windowHeight,
  availLeft: 0,
  availTop: 0
};
//# sourceMappingURL=screen.js.map